import React, { Component } from 'react'
import ResultItem from './ResultItem'
import Translations from '../../../TranslationsWrapper'

class Result extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <div className="c-location-finder__results">
        <h2>
          {this.props.searchResults.length}{' '}
          {this.props.translations.Results.Title}
        </h2>

        <div className="c-location-finder__result__list">
          {this.props.searchResults.map((resultItem, index) => {
            return <ResultItem key={index} data={resultItem} />
          })}
        </div>
      </div>
    )
  }
}

export default Translations('js-location-finder')(Result)
